import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

interface StickyBarProps {
  name: string;
  zips: string[];
}

export default function StickyBar({ name, zips }: StickyBarProps) {
  const { t } = useLanguage();
  return (
    <div className="sticky top-[80px] z-40 bg-[#064e3b] text-white py-3 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 flex flex-wrap items-center justify-between gap-2">
        <div className="flex items-center gap-2 text-sm">
          <Link to="/" className="hover:text-[#fbbf24] transition-colors">{t("nav.home")}</Link>
          <i className="ri-arrow-right-s-line text-white/50" />
          <span className="text-white/70">{t("hood.breadcrumbServiceAreas")}</span>
          <i className="ri-arrow-right-s-line text-white/50" />
          <span className="font-bold">{name}</span>
        </div>
        <div className="flex items-center gap-4 text-sm">
          <span className="text-white/80">{zips.join(" · ")}</span>
          <a
            href="tel:+17863774452"
            className="font-bold hover:text-[#fbbf24] transition-colors whitespace-nowrap"
          >
            (786) 377-4452
          </a>
        </div>
      </div>
    </div>
  );
}